"use client";
import React from "react";
import { Link } from "react-router-dom";

export default function ProjectCard({ title, published, href }) {
  return (
    <Link
      to={href}
      className="relative block rounded-lg p-[0.4rem] cursor-pointer no-underline z-10"
    >
      <div className="w-full h-full">
        <div className="m-0 font-semibold eduheder mb-[0.6rem]">{title}</div>
        <span className="text-zinc-300 text-xs m-0">
          {new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }).format(new Date(published))}
        </span>
      </div>
    </Link>
  );
}
